import DownloadMinimalistic from '@betfan/icons/linear/ArrowsAction/DownloadMinimalistic.svg?react';
import installPwaTextImg from 'assets/images/install-pwa-text.svg';
import { DSButton } from 'designSystem';
import { AppStoreButton } from 'features/appStoreButton/appStoreButton';
import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { addNotification } from 'shared/components/toast';
import { getDeviceType } from 'shared/hooks/useDeviceManager';
import usePwaPrompt from 'shared/hooks/usePwaPrompt';
import { sendAppInstallCloseEvent, sendAppInstallStartEvent, sendAppInstallSuccessEvent } from '../analytics';

interface Props {
	className: string;
}

const BaseUserPanel: React.FC<Props> = (props) => {
	const { t } = useTranslation();
	const device = getDeviceType();
	const pwaPrompt = usePwaPrompt();
	const [show, setShow] = useState(false);
	const isIos = device?.deviceType === 'ios';

	const shouldShowNativeAppBanner = () => {
		if (device) {
			const android =
				pwaPrompt.canInstall && (device.deviceType === 'android' || device.deviceType === 'desktop') && device.clientType === 'browser';
			const ios = device.deviceType === 'ios' && device.clientType !== 'native';
			return android || ios;
		} else {
			return false;
		}
	};

	const initialize = () => {
		setShow(shouldShowNativeAppBanner());
	};

	const install = () => {
		sendAppInstallStartEvent('panel');
		pwaPrompt
			.install()
			.then((status) => {
				if (status === 'accepted') {
					sendAppInstallSuccessEvent('panel');
					setShow(false);
				} else {
					sendAppInstallCloseEvent();
				}
			})
			.catch(() => {
				addNotification('error', t('installPwaError'));
			});
	};

	useEffect(() => {
		initialize();
	}, [pwaPrompt.canInstall]);

	return show ? (
		<div className={props.className}>
			<div className={'flex items-center justify-between rounded-4 h-[75px] px-2 py-4 w-full bg-primary-500 relative'}>
				<img alt="Zainstaluj naszą apkę!" src={installPwaTextImg} className="object-contain h-full mr-1" />

				{!isIos ? (
					<DSButton color="primary" leftIcon={DownloadMinimalistic} size="small" onClick={install}>
						{t('installPwaButton')}
					</DSButton>
				) : (
					<AppStoreButton location="panel" />
				)}
			</div>
		</div>
	) : null;
};

export const UserPanel = memo(BaseUserPanel);
